// components/ConsentModal.tsx
"use client";
import { useState } from "react";
import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Text,
  VStack,
  Switch,
  Button,
} from "@chakra-ui/react";
import { useAppContext } from "hooks";
import videoThumbnail from "@public/thumbnail.png";
import Link from "next/link"; 

const ConsentModal = ({
  isOpen,
  onConsentChange,
  onClose,
}: {
  isOpen: boolean;
  onConsentChange: any;
  onClose: () => void;
}) => {
  const { profile } = useAppContext();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [nsfwConsent, setNsfwConsent] = useState<boolean>(profile?.nsfw_consent || true);

  const [newsletterConsent, setNewsletterConsent] = useState<boolean>(
    profile?.newsletter_consent ?? true
  );

  const [adultConsent, setAdultConsent] = useState<boolean>(profile?.adult_consent || true);

  const handleConfirmClick = () => {
    if (adultConsent === false) {
      setErrorMessage("You need to be 18+ to continue");
      return;
    }

    onConsentChange.setNsfwConsent(nsfwConsent);
    onConsentChange.setNewsletterConsent(newsletterConsent);
    onConsentChange.setAdultConsent(adultConsent);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent bg="rgba(10,14,29, 0.9)">
        <ModalCloseButton />
        <ModalBody>
          <Flex h="95vh" justify="center" direction="column" align="center">
            <Text
              style={{
                background: "linear-gradient(to right,  #FFB5FF , #1AA5D3 )",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                MozBackgroundClip: "text",
              }}
              fontSize={{ base: "24px", lg: "58px" }}
              fontWeight="semibold"
              textAlign="center"
            >
              Welcome to DeepMode
            </Text>
            <Text fontSize={{ base: "14px", md: "16px" }} mb="15px">
              DeepMode is easy to use! Just watch!
            </Text>
            <Flex w={{ base: "320px", md: "480px" }} h={{ base: "240px", md: "320px" }}>
              <video
                width="100%"
                height="100%"
                controls
                preload="none"
                poster={videoThumbnail.src}
                autoPlay // Adds auto-play functionality
                muted // Ensures the video plays without sound
              >
                <source
                  src={"https://deepmodeassets.s3.eu-west-1.amazonaws.com/DeepFinalV1.mp4"}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </Flex>
            <Text mt="20px" fontSize={{ base: "14px", md: "16px" }} textAlign="center">
              Please take a second to confirm your preferences
            </Text>
            <VStack align="start" mt={{ base: "20px", md: "50px" }}>
              {/* Newsletter Consent Section */}
              <Flex align="center">
                <Switch
                  isChecked={newsletterConsent}
                  onChange={() => setNewsletterConsent(!newsletterConsent)}
                />
                <Text
                  ml="15px"
                  fontSize={{ base: "14px", md: "16px" }}
                  fontWeight={{ base: 500, md: 600 }}
                >
                  Sign up for our Newsletter and get 20 Free Credits (Optional)
                </Text>
              </Flex>
              
              {/* Terms and Conditions Section Without Toggle */}
              <Flex align="center" mt="20px">
              <Text
                fontSize={{ base: "14px", md: "16px" }}
                fontWeight={{ base: 500, md: 600 }}
              >
                By continuing, you agree and acknowledge our{" "}
                <Link href="/terms-and-conditions" passHref target="_blank" rel="noopener noreferrer">
                  <span
                    style={{
                      color: "#FF1B6D",
                      cursor: "pointer",
                      textDecoration: "underline", // Underline the text
                    }}
                  >
                    Terms & Privacy
                  </span>
                </Link>.
              </Text>

              </Flex>
            </VStack>


            <Button
              color="white"
              bg="button.500"
              minH="40px"
              w="150px"
              mt={{ base: "20px", md: "50px" }}
              onClick={handleConfirmClick}
            >
              Confirm
            </Button>
            <Text mt="15px" color="red">
              {errorMessage}
            </Text>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConsentModal;
